import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {BaseDeterminantBuilder} from "../../core/base-determinant-builder/base-determinant-builder";
import {RegistrationControllerService} from "../../services/registration-controller/registration-controller.service";
import {RegistrationService} from "../../services/registration-controller/registration.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CostService} from "../../services/cost-controller/cost.service";
import {DeterminantControllerService} from "../../services/registration-controller/determinant-controller.service";
import {Store} from "../../services/store.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "determinant-builder-new",
  templateUrl: "./determinant-builder-new.component.html",
})
export class DeterminantBuilderNewComponent extends BaseDeterminantBuilder implements OnInit {

  @Input() public serviceId: string;
  @Input() public jsonString: string;
  @Input() public noneSelectedText = "No determinants selected yet";
  @Input() public noneSelectedSubText = "Drag and drop determinants";
  @Input() public showSaveCancelRow = true;
  @Input() public lateralSpacing = false;
  @Output() public onSave = new EventEmitter();
  @Output() public onCancel = new EventEmitter();
  @Output() public onChange = new EventEmitter();
  @Output() public onAddModalOpened = new EventEmitter();
  @Output() public onEditModalOpened = new EventEmitter();

  public prefix: string;

  constructor(private determinantService: DeterminantControllerService) {
    super();
  }

  public ngOnInit(): void {
    this.prefix = "dbn" + this.getRandomInt(1, 100000);
    this.getServiceDeterminantKeyName();
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public onChanged(event: any) {
    this.jsonString = event.jsonString;
  }

  public getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  _appendDeterminant = (det) =>  {
    if (typeof this.jsonString === 'string') {
      this.jsonString = JSON.stringify(this.appendDeterminant(det, JSON.parse(this.jsonString)));
    }
    // TODO: why got object type?
    else if (typeof this.jsonString === 'object') {
      this.jsonString = JSON.stringify(this.appendDeterminant(det, this.jsonString));
    }
    this.onChange.emit({jsonString: this.jsonString});
  };
}
